import { createSlice } from '@reduxjs/toolkit';

import { apiOperation, padZeros } from '@/app/api/common';

export interface TagInfo {
  tag:				string;
  desc:		string;
}

export interface TagsHolder {
  tags:				TagInfo[];
}

export const tagsUrl = "/tags.json";

const initialState: TagsHolder = {
  tags:			[],
}

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    assign: (state, action) => {
      state.tags = action.payload.tags;
    },
    setTags: (state, action) => {
      state.tags = action.payload;
    },
  },
});

export function copyTagDescriptor(desc: TagInfo): TagInfo {
  return {
    tag:				desc.tag,
    desc:		desc.desc,
  };
}

export function copyTagDescriptors(descs: TagInfo[]): TagInfo[] {
  if (!descs)
    return [];

  return descs.map((desc: TagInfo) => copyTagDescriptor(desc));
}

export function copyTagsHolder(holder: TagsHolder): TagsHolder {
  return {
    tags:				copyTagDescriptors(holder.tags),
  };
}

export function getNewTagDescriptor(): TagInfo {
  return {
    tag:				"",
    desc:		"",
  };
}
